/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';
import '../Registrationsetup.scss';
import GetAdminConfiguration from '../../../api/GetAdminConfig';
import DefaultPermissionGroups from './DefaultPermissionGroups';

const DefaultPermissionTab = (props) => {
  const { onChange, hasEditPermission } = props;
  const { values, errors } = props;
  const { defaultPermissionEditable } = props;
  const { defaultPermissionName } = props;

  const iIndex = props.iIndex;

  const [MappedEntitiesData, setMappedEntitiesData] = React.useState([]);
  const [GroupData, setGroupData] = React.useState([defaultPermissionName]);

  const clearMappedEntities = () => {
    setMappedEntitiesData([]);
  };

  const cleanMappedEntities = () => {
    const temp = cloneMappedEntities();

    if (temp && temp?.length === 0) {
      return [];
    }

    //removes last blob if blank
    if (temp[temp?.length - 1].BlkOfBusOid === '') {
      temp.splice(temp?.length - 1, 1);
    }

    return temp;
  };

  //Insurer User Type handlers
  const cloneMappedEntities = () => {
    const temp = [...MappedEntitiesData];
    for (let i = 0; i < MappedEntitiesData?.length; i++) {
      temp[i].Client = [...MappedEntitiesData[i].Client];
      for (let k = 0; k < MappedEntitiesData[i].Client?.length; k++) {
        temp[i].Client[k].Location = [
          ...MappedEntitiesData[i].Client[k].Location,
        ];
      }
    }
    return temp || [];
  };

  const handleInsurerBlobChange = (id, bIndex, value = '') => {
    const temp = cloneMappedEntities();
    if (id === 'REMOVE') {
      temp.splice(bIndex, 1);
    } else if (temp[bIndex]?.BlkOfBusOid === id) {
      temp[bIndex].BlockOfBusinessName = value;
    } else {
      temp[bIndex] = {
        MemberOid: '',
        DependentOid: '',
        BlkOfBusOid: id,
        BlockOfBusinessName: value,
        Client: [],
      };
    }
    setMappedEntitiesData(temp);
  };

  //Group Data handlers
  const handleGroupDataChange = (id, index) => {
    const temp = [...GroupData];
    if (id === 'REMOVE') {
      temp.splice(index, 1);
    } else {
      temp[index] = id;
    }
    setGroupData(temp);
    props.setDefaultRole(props.userType, temp[0]);
  };

  const clearGroupData = () => {
    setGroupData([]);
  };

  const cleanGroupData = () => {
    const temp = [...GroupData];
    if (temp[temp?.length - 1] === '') {
      temp.splice(temp?.length - 1, 1);
    }
    setGroupData(temp);
    return temp;
  };

  return (
    <div>
      <DefaultPermissionGroups
        userType={props.userType}
        GroupData={GroupData}
        onGroupDataChange={handleGroupDataChange}
        hasEditPermission={hasEditPermission}
      />
    </div>
  );
};

export default DefaultPermissionTab;
